const ArrowDownTrendIcon = (
  <svg
    className="fill-current"
    width="10"
    height="11"
    viewBox="0 0 10 11"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M5.64284 7.69237L9.09102 4.33987L10 5.22362L5 10.0849L-8.98488e-07 5.22362L0.908973 4.33987L4.35716 7.69237L4.35716 0.0848701L5.64284 0.0848704L5.64284 7.69237Z" />
  </svg>
);

export default ArrowDownTrendIcon;
